module.exports = __webpack_public_path__ + "static/media/FMD.5ac49071.jpg";